<app-workflow-conditions
  [variables]="variables"
  [value]="group"
  (valueChange)="group = $event"
  (compiledChange)="onCompiledChange($event)">
</app-workflow-conditions>


